/**
 *
 * Ciclo di vita
 *
 * 1. Setup
 * 2. Page Ready Event
 * 3. Hide Loader
 *
 */
import { CustomAccordionV1 } from "../components/custom-accordion-v1/custom-accordion-v1";


export class Page {

	pageTitle: string;
	debug: boolean;

	page: HTMLElement;

	counterEffectObserver: IntersectionObserver;


	constructor() {
		this.debug = false;
		this.page = document.querySelector('main');
	}


	pageSetup() {

		if ( this.page.querySelector('.counter') ) {

			this.counterEffectObserver = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if ( entry.isIntersecting ) {
						import('../components/counter/counter').then( c => {
							this.page.querySelectorAll('.counter').forEach( (el: HTMLElement) => new c.Counter(el) );
						});
					}
				});
			}, { threshold: .5 });

			this.page.querySelectorAll('.counter')
				.forEach(target => this.counterEffectObserver.observe(target));

		}

		if ( document.getElementById('newsletterModal') ) {
			import('../components/NewsletterModal').then( c => new c.NewsletterModal() );
		}

		if ( document.querySelector('#popup-happy-days-2024') ) {
			import('../landing/HappyDays').then( c => new c.HappyDays() );
		}

		if ( document.querySelector('.custom-related-posts-v1') ) {
			import('../components/CustomRelatedPosts').then( c => new c.CustomRelatedPosts() );
		}

		if ( document.querySelector('.custom-timeline-posts-v1') ) {
			import('../components/CustomTimelinePosts').then( c => new c.CustomTimelinePosts() );
		}

		if ( document.querySelector('.custom-accordion-v1') ) {
			import('../components/custom-accordion-v1/custom-accordion-v1').then( c => new c.CustomAccordionV1() );
		}

		if ( document.querySelector('.custom-classic-accordion-v1') ) {
			import('../components/custom-classic-accordion-v1/custom-classic-accordion-v1').then( c => new c.CustomClassicAccordionV1() );
		}

	}


	pageReady() {

	}

}

